import Recurso_3logo from "../../assets/logo45-5.png";
import FormDefault from "../../components/Forms/FormDefault";
import * as Yup from "yup";
import { request } from "../../components/services/RequestService";
import { useAuth } from "../../contexts/AuthContext";
import { validateArray } from "../../utils/validate";
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { H1, H3 } from "../../components/Text";
import { RequestNoAuth } from "../../hooks/RequestNoAuth";
import React from "react";
import styled from "styled-components";
import embarquePortada from "../../assets/enbarqued.jpg";

const FormLogin = (props) => {
  const {
    data,
    title,
    fields,
    validationSchema,
    onSubmit,
    buttonName,
    redirect,
  } = props;

  return (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(0, 100, 0, 0.2), rgba(0, 100, 0, 0.2)), url('https://res.cloudinary.com/joeldes/image/upload/v1759180852/SCZPlus/embarqued_dghf7a.jpg')`,
      }}
      className="bg-cover bg-center flex justify-center items-center w-screen h-screen"
    >
      <FormStyle data={data}>
        <div className="bg-[#ffffff]/20 backdrop-blur-sm shadow-md w-full p-8 mx-4 rounded-2xl flex flex-col justify-center items-center sm:w-[400px]">
          <img
            className="w-[100px] sm:w-[250px] bg-white px-6 py-4 rounded-lg"
            src={data.logo}
            alt="logo de trazo"
          />
          {/* <H1 className="text-[25px]">{title}</H1> */}
          <div className="w-full">
            <FormDefault
              fields={fields}
              initialValues={{
                UsernameOrEmail: "",
                password: "",
              }}
              validationSchema={Yup.object().shape(validationSchema)}
              onSubmit={onSubmit}
              classNameBtn={`text-gray-200`}
              buttonName={buttonName}
            />
          </div>
          <H3 className="text-gray-200 mt-2">
            {redirect ? (
              redirect
            ) : (
              <Link to="/auth/recover">
                ¿Olvidaste tu{" "}
                <span style={{ color: "#f8f8f8" }}>contraseña</span>?
              </Link>
            )}
          </H3>
        </div>
      </FormStyle>
      <img
        className="w-[70px] hidden absolute left-0 bottom-0 sm:w-[120px] m-6 sm:block"
        src={Recurso_3logo}
        alt="logo de trazo"
      />
    </div>
  );
};

const FormStyle = styled.div`
  & h1 {
    color: ${(props) => `#${props.data.color1}`};
  }
  & label {
    color: ${(props) => `#${props.data.color2}`};
  }
  & button {
    background: ${(props) => `#${props.data.color_buttons}`};
  }
  & span {
    color: ${(props) => `#${props.data.color1}`};
  }
`;
export default FormLogin;
